import {ActiveRecord} from '../ActiveRecord';
import config from 'config';
import {LiveImageDTO, LiveImage} from "../image";
import isUndefined = require("lodash/isUndefined");
import {CountryDTO} from "../country";

export class StreamImageDTO extends LiveImageDTO {
  small: string;
  thumbnail: string;
}

export class StreamImage extends LiveImage {
  protected _small: string;
  protected _thumbnail: string;

  get small(): string {
    return this.isSaved ? this._small : this.url;
  }

  get thumbnail(): string {
    return this.isSaved ? this._thumbnail : this.url;
  }

  constructor(data: StreamImageDTO) {
    super(data);
    this._small = data.small;
    this._thumbnail = data.thumbnail;
  }
}

export const STREAM_EVENT_STATUS_ACTIVE = 'active';
export const STREAM_EVENT_STATUS_PENDING = 'pending';
export const STREAM_EVENT_STATUS_FINISHED = 'finished';

export const STREAM_EVENT_UPCOMING = 'upcoming';
export const STREAM_EVENT_DRAFT = 'draft';
export const STREAM_EVENT_PAST = 'past';
export const VIDEO_ON_DEMAND = 'vod';

export enum StreamEventStatusType {active, pending, finished, draft}

export interface StreamEventDTO {
  id?: string;
  logo?: StreamImageDTO;
  title: string;
  full_name?: string;
  start_time: number;
  end_time?: number;
  is_live?: boolean;
  trigger_push_notifications?: boolean;
  push_notifications_triggered?: boolean;
  vip_only?: boolean;
  m3u8?: string;
  m3u8_backup?: string;
  duration?: number;
  draft: boolean;
  description: string;
  countries?: CountryDTO[];
  country_codes?: Array<string>;
}

export class CustomStreamEvent extends ActiveRecord {
  title: string;
  m3u8: string;
  m3u8_backup: string;
  startDate: Date;
  endDate: Date;
  is_live: boolean;
  push_notifications_triggered: boolean;
  logo: LiveImage;
  duration: number;
  protected _status: StreamEventStatusType = StreamEventStatusType.draft;

  static path = `${config.backOfficeBasePath}/custom_streams/streams`;

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  static parseData(data: StreamEventDTO): CustomStreamEvent {
    let res = new CustomStreamEvent({});

    return Object.assign(res, res._parseData(data));
  }

  prepareForSave(data): StreamEventDTO {
    
    return {
      title: data.title,
      m3u8: data.m3u8,
      logo: data.logo && !data.logo.isSaved ? data.logo.file : undefined,
      m3u8_backup: data.m3u8_backup,
      start_time: data.startDate.getTime(),
      end_time: data.startDate.getTime() + 10000,
      is_live: data.is_live,
      trigger_push_notifications: data.trigger_push_notifications,
      vip_only: data.vip_only,
      draft: false,
      description: data.description,
      country_codes: data.countries
    };
  }

  _parseData(data: StreamEventDTO) {
    let res: any = {
      id: data.id,
      // hack for api
      title: data.full_name,
      m3u8: data.m3u8,
      m3u8_backup: data.m3u8_backup,
      is_live: data.is_live,
      trigger_push_notifications: data.id ? false : true,
      push_notifications_triggered: data.push_notifications_triggered,
      vip_only: data.vip_only,
      duration: data.duration,
      startDate: new Date(data.start_time),
      endDate: new Date(data.end_time),
      logo: new StreamImage(Object.assign(new StreamImageDTO(), data.logo)),
      description: data.description,
      _status: data.draft === true
        ? StreamEventStatusType.draft
        : (data.is_live ? StreamEventStatusType.active :
        (data.end_time < Date.now() ? StreamEventStatusType.finished : StreamEventStatusType.pending)),
      countries: data.countries.map(country => country.code)
    };

    return res;
  }

  get draft(): boolean {
    return this._status === StreamEventStatusType.draft;
  }

  get status(): StreamEventStatusType {
    return this._status;
  }

  get hasVideo(): boolean {
    return this.m3u8 !== undefined;
  }

  async publish(data): Promise<CustomStreamEvent> {
    return <CustomStreamEvent> await this.save(Object.assign(data, {draft: false}));
  }

  protected async _updateRecord(dataForSave) {
    let res = await this._networkLayer.patchFormData(this._prepareUrl(this.id), dataForSave);
    return await res.json();
  }

  protected async _createRecord(dataForSave) {
    let res = await this._networkLayer.postFormData(this._prepareUrl(), dataForSave);
    return await res.json();
  }
}



// WEBPACK FOOTER //
// ./src/api/stream/CustomStreamEvent.ts